import '@ionic/react/css/core.css'
import React, { useEffect, useState } from "react";

import {
  RetorikAgent,
  //RetorikWidget,
  //characters,
  sendEvent,
  AvailableViews,
  AvailableSubViews
} from "@davi-ai/retorik-framework";
import type {
  AddressData,
  WidgetConfiguration,
  //ChatbotData,
  Configuration,
  RetorikMenusConfiguration
  //ViewsConfiguration,
  //RetorikThemeColors,
} from "@davi-ai/retorik-framework";
import { tenants, userData } from "./data";
import { MapIcon, Map, labels, Tenant } from "@davi-ai/retorik-map";

import { FullMenu } from '@davi-ai/retorik-framework-hospitality'
import { setupIonicReact } from '@ionic/react'
setupIonicReact()

const addressData: AddressData = tenants.OTNievre;

const widgetConfig: WidgetConfiguration =
{
  button: {
    text: {
      color: '#fff',
      content: 'BESOIN D\'AIDE'
    },
    image: {
      url: 'images/lea@2x.png',
      height: "3rem",
      marginY: true
    },
    border: {
      color: '#fff'
    },
    background: {
      color: "#0082CA"
    }
  },
  large: {}
}

const hospitalityFullMenu = new FullMenu(sendEvent).menu
const tenantList: { [key: string]: Tenant } = {};
const defaultMenusConfig: RetorikMenusConfiguration = {
  baseMenu: [
    { view: AvailableViews.home, indice: 1 },
    {
      customDisplay: "mapDisplay",
      label: labels,
      /*{
        "fr-FR": "Carte Interactive",
        "en-US": "Interactive map",
      },*/
      icon: <MapIcon />,
      indice: 2,
    },
    { view: AvailableViews.news, indice: 3 },
    { view: AvailableViews.weather, indice: 4 },
    { view: AvailableViews.emergency, indice: 5 }
  ],
  customMenu: [
    hospitalityFullMenu,
    []
  ],
  subMenu: [
    { view: AvailableSubViews.history, indice: 1 },
    { view: AvailableSubViews.tutorial, indice: 2 }
  ]
};

const defaultConfig: Configuration = {
  position: {
    searchForLocation: true,
  },
  ...defaultMenusConfig
}

const App = () => {
  const [props, setProps] = useState<any>();
  useEffect(() => {
    tenantList["OTNievre"] = {
      name: "OTNievre",
      retorikName: "OTNievre",
      areaLocation: [],
      aroundMeDistance: 1500,
    };
    const retorikMap = (
      <Map
        activeTenant={"OTNievre"}
        tenantList={tenantList}
        userLocation={{          
          lat: 46.98333,
          lng: 3.16667
        }}
      />
    );
    setProps({
      addressData: addressData,
      userData: userData,
      widgetConfig,
      config: defaultConfig,
      externalComponents: [{ component: retorikMap, name: "mapDisplay" }],
    });
  }, [])

  return (props ?
    <RetorikAgent
      {...props} />
    :
    (
      <></>
    )
  );
};

export default App;